<template>
    <el-row>
        <el-col :span="20" :offset="2">
            <el-row>
                <el-col :span="12">
                    <h1 align="left">CS Profile</h1>
                </el-col>
                <el-col :span="12" align="right">
                    <el-button type="primary" icon="el-icon-add" @click="dialogVisible = true">เพิ่ม</el-button>
                </el-col>
            </el-row>
            <el-table
                ref="OrderList"
                :data="CsList"
                :header-cell-style="{
                    'background-color': 'black',
                    color: 'white'
                }"
                style="width: 100%; margin-top: 10px;"
                align="left"
                v-loading="loading"
            >
                <el-table-column label="CS Code" width="150"
                    ><template slot-scope="scope">
                        {{ scope.row.code }}</template
                    ></el-table-column
                >
                <el-table-column label="ชื่อ - นามสกุล" width=""
                    ><template slot-scope="scope">
                        {{ scope.row.name }}</template
                    ></el-table-column
                >
                <el-table-column label="ชื่อเล่น" width="150"
                    ><template slot-scope="scope">
                        {{ scope.row.name }}</template
                    ></el-table-column
                >
                <el-table-column label="เบอร์โทร" width="150"
                    ><template slot-scope="scope">
                        {{ scope.row.phone }}</template
                    ></el-table-column
                >
                <el-table-column label="Email" width="150"
                    ><template slot-scope="scope">
                        {{ scope.row.email }}</template
                    ></el-table-column
                >
                <el-table-column label="สิทธ์" width="150"
                    >
                    <template slot-scope="scope">
                       <span v-for="role in scope.row.roles" :key="role"> {{ role.action }} </span>
                    </template
                    ></el-table-column
                >
                <el-table-column label="แก้ไข" width="150"
                    ><template>
                        <el-button type="primary" icon="el-icon-edit" circle></el-button>
                    </template
                    ></el-table-column
                >
            </el-table>

            <el-col style="margin-top:10px;">
                <el-pagination
                @size-change="changeLimitPage"
                @current-change="changeCurrentPage"
                :current-page.sync="pagination.currentPage"
                :page-sizes="pagination.pageSizes"
                :page-size="10"
                layout="prev, pager, next, sizes"
                :total="pagination.allPage * pagination.limit"
                >

                </el-pagination>
            </el-col>

        </el-col>
        <el-dialog
            :visible.sync="dialogVisible"
            width="60%"
            hight="100%"
           >
            <el-col :span="12" align="left">
                <h6>ข้อมูลส่วนตัว</h6>
                <el-input placeholder="E-mail" v-model="CsData.email"></el-input>
                <el-input placeholder="ชื่อ - นามสกุล" v-model="CsData.name"></el-input>
                <el-input placeholder="ชื่อเล่น" v-model="CsData.nick_name"></el-input>
                <el-input placeholder="เบอร์โทร" v-model="CsData.phone"></el-input>
                <el-input placeholder="CS code" v-model="CsData.code"></el-input>
            </el-col>

            <el-col :span="12" align="left">
                <div style="margin-left: 30px;">
                    <h6 >สิทธิ์การเข้าถึง</h6>
                    <el-row>
                        <el-checkbox v-model="CsData.roles"> เข้าถึง CS All Case</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles" style="margin-left: 20px;"> เห็นทุก Case</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles" style="margin-left: 20px;"> เห็นเฉพาะ Case ของตัวเอง</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles"> สิทธิในการเพิ่ม Flag Case</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles"> เข้าถึง CS Profile</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles" style="margin-left: 20px;"> เพิ่ม CS Profile</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles" style="margin-left: 20px;"> แก้ไข CS Profile</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles"> สิทธิในการดู CS Preformace</el-checkbox>
                    </el-row>
                    <el-row>
                        <el-checkbox v-model="CsData.roles"> สิทธิในการเพิ่มเหตุผลหลัก เหตุผลรอง</el-checkbox>
                    </el-row>
                </div>
            </el-col>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                <el-button type="primary" @click="dialogVisible = false">บันทึก</el-button>
            </span>
        </el-dialog>
    </el-row>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'GenerateNotify',
    data () {
        return {
            dialogVisible: false,
            loading: false,
            CsData: {
                code: 'SP1',
                name: 'Rodriguez Delgado',
                nick_name: 'Jarb1',
                email: 'rodriguezdelgado@konnect.com',
                phone: '(829) 588-2292',
                roles: true
            },
            CsList: [],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            filterDate: null
        }
    },
    created () {
        this.getdata()
    },
    methods: {
        filterNotify () {
            console.log('--------------filterDate---------------')
        },
        async getdata () {
            console.log('-----------listNotify----------------')
            var CsListData = await fgApi.caseTracking.getListCsProfile(this.pagination.limit, this.pagination.offset)
            this.CsList = CsListData.data.result
            this.pagination.allPage = CsListData.data.all_page
            console.log(CsListData)
        },
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchOrder()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.fetchOrder()
        }
    }
}
</script>
